var _path, _path2, _path3, _path4, _ellipse, _ellipse2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.2 3.48V.76H49.46V17h3.02v-6.88h61.78v-2.6H52.48V3.48h7.72Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.34 0v16.24h6.14c4.79 0 7.61-2.78 7.61-7.98 0-5.82-3.58-8.26-7.42-8.26h-6.33Zm3.04 2.74h2.5c3.02 0 5 1.51 5 5.52 0 4.57-2.1 5.24-5.62 5.24h-1.88V2.74Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78 8.56c0 4.55 2.94 8.5 7.73 8.5 5.84 0 7.84-4.94 7.84-8.62 0-4.4-2.83-8.44-7.78-8.44C81.1 0 78 3.8 78 8.56Zm3.13-.12c0-3.56 1.97-5.66 4.64-5.66 3.22 0 4.74 3.02 4.74 5.91 0 3.68-2.28 5.55-4.7 5.55-3.47 0-4.68-3.27-4.68-5.8ZM61.69 8.56c0 4.55 2.94 8.5 7.73 8.5 5.84 0 7.84-4.94 7.84-8.62 0-4.4-2.83-8.44-7.77-8.44-4.7 0-7.8 3.8-7.8 8.56Zm3.13-.12c0-3.56 1.98-5.66 4.64-5.66 3.22 0 4.74 3.02 4.74 5.91 0 3.68-2.28 5.55-4.7 5.55-3.46 0-4.68-3.27-4.68-5.8Z",
    fill: "#FFD25E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.49 17 8.95.76H5.5L0 17h3.27l.94-3.17h6.1l.94 3.17h3.24Zm-5-5.84H5.02l2.26-7.48 2.23 7.48ZM30.25 17V.76h-3c.03.37.37 11.46.37 11.46L20.42.76H17.7V17h2.96l-.18-11.39L27.57 17h2.68ZM46 .76h-3.4l-3.54 6.72L35.54.76H32.1l5.43 9.82V17h3.01v-6.42L46.01.76Z",
    fill: "#fff"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 69.5,
    cy: 8.5,
    rx: 5.5,
    ry: 6.5,
    fill: "#FFD25D"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.5,
    cy: 8.5,
    rx: 5.5,
    ry: 6.5,
    fill: "#FFD25D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e989d7347dc1d67f207c20810cc608b3.svg";
export { ForwardRef as ReactComponent };